import React from "react";
import { Container, Row, Col } from "reactstrap";
//Import Images
import maintanence from "../../../assets/images/coming-soon.svg";
// import logoDark from "../../assets/images/logo/pappermap-logo-wordmark--dark 1.png";
// import logoLight from "../../assets/images/logo/pappermap-logo-wordmark--light 1.png";

const Maintenance = ({ title }) => {
  return (
    <div className="my-5 pt-sm-5">
      <Container>
        <Row>
          <Col lg="12">
            <div className="text-center">
              {/* <Link to="/dashboard" className="d-block auth-logo">
                      <img
                        src={logoLight}
                        alt="logo"
                        className="auth-logo-dark mx-auto"
                        height="36"
                      />
                      <img
                        src={logoDark}
                        alt="logo"
                        className="auth-logo-light mx-auto"
                        height="36"
                      />
                    </Link> */}
              <Row className="justify-content-center mt-5">
                <Col sm="4">
                  <div className="maintenance-img">
                    <img
                      src={maintanence}
                      alt=""
                      className="img-fluid mx-auto d-block"
                    />
                  </div>
                </Col>
              </Row>
              <h4 className="mt-5">{title}</h4>
              <p className="text-muted">
                We're working hard to bring you an amazing experience!
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Maintenance;
